export default class ServiceService {
	constructor(apiService) {
		this.apiService = apiService
	}


	getEntity(id, params) {
		return this.apiService.callGet('me/serviceWeightCategories/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/serviceWeightCategories', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/serviceWeightCategories/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/serviceWeightCategories/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/serviceWeightCategories', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ServiceWeightCategoryService.js